import store from "@/plugins/store"

export default class Store {
    static set(name, val) {
        store.commit('set', [name, val])
    }
}
